document.addEventListener('DOMContentLoaded', () => {
	const tabs = document.querySelectorAll('[data-media-filter]');
	const cards = document.querySelectorAll('.js-media-card');
	const lightbox = document.querySelector('[data-media-lightbox-modal]');
	const lightboxImage = document.querySelector('[data-media-lightbox-image]');
	const lightboxCaption = document.querySelector('[data-media-lightbox-caption]');
	const closeButton = document.querySelector('[data-media-lightbox-close]');
	const prevButton = document.querySelector('[data-media-lightbox-prev]');
	const nextButton = document.querySelector('[data-media-lightbox-next]');
	let activeGallery = [];
	let activeIndex = 0;

	if (tabs.length && cards.length) {
		tabs.forEach(tab => {
			tab.addEventListener('click', () => {
				const filter = tab.dataset.mediaFilter;

				tabs.forEach(item => item.classList.remove('active'));
				tab.classList.add('active');

				cards.forEach(card => {
					card.classList.toggle('hidden', filter !== 'all' && card.dataset.mediaType !== filter);
				});
			});
		});
	}

	const getGalleryItems = group => {
		return Array.from(document.querySelectorAll(`[data-media-lightbox][data-media-group="${group}"]`));
	};

	const showLightboxItem = index => {
		if (!activeGallery.length || !lightbox || !lightboxImage) {
			return;
		}

		activeIndex = (index + activeGallery.length) % activeGallery.length;
		const item = activeGallery[activeIndex];

		lightboxImage.src = item.href;
		lightboxImage.alt = item.dataset.mediaTitle || '';

		if (lightboxCaption) {
			lightboxCaption.textContent = `${item.dataset.mediaTitle || ''} ${activeIndex + 1}/${activeGallery.length}`;
		}
	};

	const openLightbox = (group, index = 0) => {
		activeGallery = getGalleryItems(group);

		if (!activeGallery.length || !lightbox) {
			return;
		}

		lightbox.classList.add('is-open');
		lightbox.setAttribute('aria-hidden', 'false');
		document.documentElement.classList.add('lock');
		document.body.classList.add('lock');
		showLightboxItem(index);
	};

	const closeLightbox = () => {
		if (!lightbox) {
			return;
		}

		lightbox.classList.remove('is-open');
		lightbox.setAttribute('aria-hidden', 'true');
		document.documentElement.classList.remove('lock');
		document.body.classList.remove('lock');

		if (lightboxImage) {
			lightboxImage.src = '';
		}
	};

	document.querySelectorAll('[data-media-lightbox]').forEach(item => {
		item.addEventListener('click', event => {
			event.preventDefault();
			const group = item.dataset.mediaGroup;
			const gallery = getGalleryItems(group);
			openLightbox(group, gallery.indexOf(item));
		});
	});

	document.querySelectorAll('[data-media-gallery-open]').forEach(button => {
		button.addEventListener('click', () => {
			openLightbox(button.dataset.mediaGalleryOpen, 0);
		});
	});

	if (closeButton) {
		closeButton.addEventListener('click', closeLightbox);
	}

	if (prevButton) {
		prevButton.addEventListener('click', () => showLightboxItem(activeIndex - 1));
	}

	if (nextButton) {
		nextButton.addEventListener('click', () => showLightboxItem(activeIndex + 1));
	}

	if (lightbox) {
		lightbox.addEventListener('click', event => {
			if (event.target === lightbox) {
				closeLightbox();
			}
		});
	}

	document.addEventListener('keydown', event => {
		if (!lightbox || !lightbox.classList.contains('is-open')) {
			return;
		}

		if (event.key === 'Escape') {
			closeLightbox();
		}

		if (event.key === 'ArrowLeft') {
			showLightboxItem(activeIndex - 1);
		}

		if (event.key === 'ArrowRight') {
			showLightboxItem(activeIndex + 1);
		}
	});
});
